export default __webpack_public_path__ + "locales/uk-UA/ChangeUserTypeDialog.json?hash=128b2d060e7b4f5697a15f40ef80a9f0";